import { render, staticRenderFns } from "./Explanations.vue?vue&type=template&id=a4615694&scoped=true&"
import script from "./Explanations.vue?vue&type=script&lang=js&"
export * from "./Explanations.vue?vue&type=script&lang=js&"
import style0 from "./Explanations.vue?vue&type=style&index=0&id=a4615694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4615694",
  null
  
)

export default component.exports